export default __webpack_public_path__ + "static/media/weekly-slots.92f7bc97.svg";